import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { SvgHelperWrapper } from 'src/components';
import Star from '../../assets/star.svg';
import * as S from './styles';

const msgs = defineMessages({
  quote: {
    id: 'new_plans_hero_quote',
    defaultMessage:
      '"I just had an honest-to-god conversation in French with a friend in Quebec, because of Memrise!"',
  },
  author: {
    id: 'new_plans_hero_quote_author',
    defaultMessage: 'Emma · PRO member',
  },
});

export const MobileTestimonial: FC = () => {
  const intl = useIntl();

  return (
    <S.Container data-testid="mobile-testimonial">
      <S.Avatar>E</S.Avatar>
      <div>
        <S.QuoteText>{intl.formatMessage(msgs.quote)}</S.QuoteText>
        <S.Stars>
          {['star-1', 'star-2', 'star-3', 'star-4', 'star-5'].map(key => (
            <SvgHelperWrapper Svg={Star} key={key} />
          ))}
        </S.Stars>
        <S.Author>{intl.formatMessage(msgs.author)}</S.Author>
      </div>
    </S.Container>
  );
};
